import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
  },
  {
    path: '/clients/login',
    name: 'client-login',
    component: () => import(/* webpackChunkName: "login" */ '../views/clients/LoginView.vue')
  },
  {
    path: '/clients/dashboard',
    name: 'client-dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/clients/DashboardView.vue')
  },
  {
    path: '/clients/shop',
    name: 'client-shop',
    component: () => import(/* webpackChunkName: "shop" */ '../views/clients/ShopView.vue')
  },
  {
    path: '/clients/students',
    name: 'client-students',
    component: () => import(/* webpackChunkName: "students" */ '../views/clients/StudentsView.vue')
  },
  {
    path: '/clients/settings',
    name: 'client-settings',
    component: () => import(/* webpackChunkName: "settings" */ '../views/clients/SettingsView.vue')
  },
  {
    path: '/clients/cart',
    name: 'client-cart',
    component: () => import(/* webpackChunkName: "cart" */ '../views/clients/CartView.vue')
  },
  {
    path: '/clients/:id',
    name: 'client-scanner',
    component: () => import(/* webpackChunkName: "scanner" */ '../views/clients/ScannerView.vue')
  },
  {
    path: '/clients/purchase/:id',
    name: 'client-purchase-detail',
    component: () => import(/* webpackChunkName: "purchase-detail" */ '../views/clients/PurchaseDetailView.vue')
  },
  {
    path: '/school/login',
    name: 'school-login',
    component: () => import(/* webpackChunkName: "school-login" */ '../views/school/LoginView.vue')
  },
  {
    path: '/school/dashboard',
    name: 'school-dashboard',
    component: () => import(/* webpackChunkName: "school-dashboard" */ '../views/school/DashboardView.vue')
  },
  {
    path: '/school/shop',
    name: 'school-shop',
    component: () => import(/* webpackChunkName: "school-shop" */ '../views/school/ShopView.vue')
  },
  {
    path: '/school/clients',
    name: 'school-clients',
    component: () => import(/* webpackChunkName: "school-clients" */ '../views/school/ClientsView.vue')
  },
  {
    path: '/school/finance',
    name: 'school-finance',
    component: () => import(/* webpackChunkName: "school-finance" */ '../views/school/FinanceView.vue')
  },
  {
    path: '/school/:id',
    name: 'school-scanner',
    component: () => import(/* webpackChunkName: "school-scanner" */ '../views/school/ScannerView.vue')
  },
  {
    path: '/nakota/login',
    name: 'nakota-login',
    component: () => import(/* webpackChunkName: "nakota-login" */ '../views/nakota/LoginView.vue')
  },
  {
    path: '/nakota/dashboard',
    name: 'nakota-dashboard',
    component: () => import(/* webpackChunkName: "nakota-dashboard" */ '../views/nakota/DashboardView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const stored = localStorage.getItem('user');
  let user = null;
  if (stored) {
    try {
      user = JSON.parse(stored);
      if (user && user.role !== 'client' && user.must_change_password) {
        delete user.must_change_password;
        localStorage.setItem('user', JSON.stringify(user));
      }
    } catch (e) {
      localStorage.removeItem('user');
    }
  }

  // 1. Redirecionamento das telas de login se já estiver autenticado
  if (to.path === '/clients/login' && user && user.role === 'client') {
    return next('/clients/dashboard');
  }
  if (to.path === '/school/login' && user && user.role === 'school') {
    return next('/school/dashboard');
  }
  if (to.path === '/nakota/login' && user && user.role === 'nakota') {
    return next('/nakota/dashboard');
  }

  // 2. Proteção de rotas da escola
  if (to.path.startsWith('/school') && to.path !== '/school/login') {
    if (!user || user.role !== 'school') {
      return next('/school/login');
    }
    
    // Se for colaborador (staff), restringe o acesso apenas para a tela de clientes e scanner de entrega
    if (user.is_staff) {
      const isClients = to.path === '/school/clients';
      const isScanner = to.path === '/school/scanner' || to.name === 'school-scanner' || (to.params.id && to.path.startsWith('/school/'));
      if (!isClients && !isScanner) {
        return next('/school/clients');
      }
    }
  }

  // 2b. Proteção de rotas do nakota (Agência Oktos)
  if (to.path.startsWith('/nakota') && to.path !== '/nakota/login') {
    if (!user || user.role !== 'nakota') {
      return next('/nakota/login');
    }
  }

  // 3. Proteção de rotas do cliente
  if (to.path.startsWith('/clients') && to.path !== '/clients/login') {
    // Permite acessar a rota do scanner do cliente para que a escola/portaria veja os itens da entrega
    const isScannerUrl = to.name === 'client-scanner' || (to.params.id && !to.path.includes('/purchase/') && !to.path.includes('/shop'));
    
    if (isScannerUrl && user && user.role === 'school') {
      return next(`/school/${to.params.id}`);
    }

    if (!isScannerUrl) {
      if (!user || user.role !== 'client') {
        return next('/clients/login');
      }
    }
  }

  next();
});

export default router;
